/** Payload key for the sidebar -> stage drag-and-drop. */
export const DND_MIME = 'application/x-floorplan-tool';
export const FloorPlanTool = {
  Pin: 'pin'
} as const;
export type FloorPlanToolType = (typeof FloorPlanTool)[keyof typeof FloorPlanTool];

export const FLOOR_PLAN_TOOLS: { id: FloorPlanToolType; label: string }[] = [
  { id: FloorPlanTool.Pin, label: 'Add Issue' }
];

// Issue marker colors based on their status.
export const STATUS_COLOR_MAP: Record<string, string> = {
  OPEN: '#EF4444',
  ASSIGNED: '#F5B301',
  IN_PROGRESS: '#2F6BFF',
  COMPLETED: '#22A447'
};

// Fallback status color for an invalid status that is assigned.
export const DEFAULT_STATUS_COLOR = '#94A3B8';

// Issue marker radius (px).
export const MARKER_RADIUS = 10;

export const CLICK_DRAG_THRESHOLD = 4;

export const MIN_ZOOM = 100;
export const MAX_ZOOM = 100000000;
export const ZOOM_STEP = 10;
